// extracted by mini-css-extract-plugin
export var item = "Item-module--item--3xDtx";
export var item__imageWrap = "Item-module--item__imageWrap--3be_P";
export var item__imageWrap__tooltip = "Item-module--item__imageWrap__tooltip--295Tr";
export var item__imageWrap__tooltip__text = "Item-module--item__imageWrap__tooltip__text--2pbqE";
export var item__subTitle = "Item-module--item__subTitle--2n7y_";